import HttpService from '../../core/services/HttpService';
import NotificationChannelHttp from '../../organization/models/NotificationChannelHttp';
import HttpCallConfig from '../../core/models/HttpCallConfig';

const httpService = HttpService.Instance;

async function handlePossibleAPIErrors(response: Response) {
  if (response.ok) {
    return;
  }

  let body;
  try {
    body = await response.json();
  } catch {
    /* @ts-ignore */
  }

  if (body && body.error) {
    throw new Error(body.error);
  }
  throw new Error(response.statusText);
}

class NotificationChannelMgmtService {
  public static async GetNotificationChannels() {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + 'notificationchannels'
    );

    await handlePossibleAPIErrors(response);

    return response.json();
  }

  public static async sendTestNotification(
      body: any,
      httpCallConfig: HttpCallConfig
    ) {
    const response = await httpService.post(
      process.env.REACT_APP_API_URL + 'notifications/test-notification',
      body,
      httpCallConfig
    );

    await handlePossibleAPIErrors(response);
  }

  public static async GetNotificationChannelHttpById(id: string): Promise<NotificationChannelHttp> {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + `notificationchannels/http/${id}`
    );

    await handlePossibleAPIErrors(response);

    return response.json();
  }

  public static async PostNotificationChannelHttp(
    notificationChannelHttp: NotificationChannelHttp,
    httpCallConfig: HttpCallConfig
  ) {
    const response = await httpService.post(
      process.env.REACT_APP_API_URL + 'notificationchannels/http',
      notificationChannelHttp,
      httpCallConfig
    );

    await handlePossibleAPIErrors(response);
  }

  public static async PutNotificationChannelHttp(
    id: string,
    notificationChannelHttp: NotificationChannelHttp,
    httpCallConfig: HttpCallConfig
  ) {
    const response = await httpService.put(
      process.env.REACT_APP_API_URL + `notificationchannels/http/${id}`,
      notificationChannelHttp,
      httpCallConfig
    );

    await handlePossibleAPIErrors(response);
  }

  public static async DeleteNotificationChannelHttp(
    id: string,
    httpCallConfig: HttpCallConfig
  ) {
    const response = await httpService.delete(
      process.env.REACT_APP_API_URL + `notificationchannels/http/${id}`,
      httpCallConfig
    );

    await handlePossibleAPIErrors(response);
  }
}

export default NotificationChannelMgmtService;



// WEBPACK FOOTER //
// ./src/modules/shared/services/NotificationChannelMgmtService.tsx